import _ from 'lodash';
import './accounts.scss';

/* @ngInject */
export default function accountsController(AccountsFactory, $stateParams, $state, UiDisplayFactory, UserData, PermissionsFactory) {
    const vm = this;

    vm.accountsPages = [];
    vm.currentPage = {};
    vm.pageUrl = '';
    vm.isEditingUser = false;
    vm.hasElevatedAccess = PermissionsFactory.hasPermission('Contractor.HasElevatedAccess') === true

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */

    vm.switchPage = function (page) {
        $state.go('accounts', { accountsPage: page.pageName, accountId: null });
    };

    vm.init = init;
    vm.getAccountsPages = getAccountsPages;
    vm.setInitialPage = setInitialPage;
    vm.setEditUserState = setEditUserState;
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Code to Run                =
	 ======================================== */

    vm.init();

    /* -----  End of Code to Run  ------*/


    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        getAccountsPages();
        setInitialPage();
        setEditUserState();
    }

    function getAccountsPages() {
        // Unfortunately have to wrap the retrieval of pages in these nested promises because
        // checkForBenji() in mainController.js needs to be completed before this executes
        UserData.getUserData().then(() => {
            UserData.getUserLocations().then((userLocations) => {
                let tempPages = AccountsFactory.getAccountsPages();
                const rules = UiDisplayFactory.getDisplayRules();
                const isCaliforniaUser = _.some(userLocations, location => location.State === 'CA');
                if (rules.isBenjiOnlyUser === true) {
                    tempPages = filterPagesForBenjiUser(tempPages);
                    tempPages = filterPagesForNonCaliforniaUser(tempPages);
                }
                else if (isCaliforniaUser === false) {
                    tempPages = filterPagesForNonCaliforniaUser(tempPages);
                }
                vm.accountsPages = tempPages;
            });
        });
    }

    function setInitialPage() {
        vm.currentPage = AccountsFactory.getCurrentAccountPage($stateParams.accountsPage);
        vm.pageUrl = vm.currentPage.url;
    }

    function setEditUserState() {
        if ($stateParams.accountsPage === 'users' && $stateParams.accountId !== null) {
            vm.isEditingUser = true;
        }
    }

    function filterPagesForBenjiUser(tempPages) {
        return _.reject(tempPages, page => page.pageName === 'financing');
    }

    function filterPagesForNonCaliforniaUser(tempPages) {
        return _.reject(tempPages, page => page.pageName === 'pcc');
    }
}



// WEBPACK FOOTER //
// ./src/app/accounts/accountsController.js